export default __webpack_public_path__ + "static/gunner_small-e5d140028b469595cfc2d22acd3a5da1.png";